export default class ViewTalkController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    talk
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.talk = talk;
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
